export const DRAWER = {
  minWidth: 0,
  maxWidth: 300,
  default: 250,
  resizerWidth: 22,
};

export const HIDE_TEXT_DRAWER_WIDTH = 150;
